import React, { lazy } from 'react';
import {Router, Switch, Route} from 'react-router-dom';
import Login from '../components/LoginPage';
import DashboardPage from '../components/DashboardPage';
import Scoreboard from '../components/Scoreboard';
import TeamDashboard from '../components/TeamDashboard';
import NotFoundPage from '../components/NotFoundPage';
import {createBrowserHistory} from 'history';
import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';
import AddCustomer from '../components/AddCustomer';
import ResetPassword from '../components/ResetPassword';
import ForgotPassword from '../components/ForgotPassword';
import Register from '../components/Register';
import DealershipDashboard from '../components/DealershipDashboard';
import PostSurvey from '../components/PostSurvey';
import NudgeToast from '../components/NudgeToast';
import auth from '../actions/auth';

// A deploy replaces the hashed chunk files, so a tab opened before it can ask for one that's
// gone. Reload once to pick up the new build instead of failing to a blank page.
const RELOADED_KEY = 'tnp.chunkReload';
const lazyPage = (load) => lazy(() => load().then(
  (mod) => {
    try { sessionStorage.removeItem(RELOADED_KEY); } catch (e) { /* storage blocked */ }
    return mod;
  },
  (err) => {
    let reloaded = false;
    try {
      reloaded = sessionStorage.getItem(RELOADED_KEY) === '1';
      sessionStorage.setItem(RELOADED_KEY, '1');
    } catch (e) { /* storage blocked: still reload, the 404 stops a loop */ }
    if (!reloaded) {
      window.location.reload();
      return new Promise(() => {});
    }
    throw err;
  }
));

// Loaded on demand: the PDF viewer (pdf.js) and the admin-only pages are most of the bundle,
// and most visitors are reps who never open them.
const DocumentsPage = lazyPage(() => import('../components/Documents'));
const AdminPage = lazyPage(() => import('../components/AdminPage'));
const AdminDealershipPage = lazyPage(() => import('../components/AdminDealershipPage'));
const AdminBootcampPage = lazyPage(() => import('../components/AdminBootcampPage'));
const RaceControlPage = lazyPage(() => import('../components/RaceControlPage'));
const RaceRepPage = lazyPage(() => import('../components/RaceRepPage'));

export const history = createBrowserHistory();

const AppRouter = () => (
  <Router history={history}>
    <div>
      <Switch>
        <PublicRoute isAuthenticated={true} path="/" exact={true} component={Login} />
        <PublicRoute path="/reset-password" exact={true} component={ResetPassword}/>
        <PublicRoute path="/forgot-password" exact={true} component={ForgotPassword}/>
        <PublicRoute path="/register" exact={true} component={Register}/>
        <PrivateRoute path="/dashboard" exact={true}  component={DashboardPage} />
        <PrivateRoute path="/addcustomer" exact={true}  component={AddCustomer} />
        <PrivateRoute path="/scoreboard"  exact={true} component={Scoreboard} />
        <PrivateRoute path="/documents"  exact={true} component={DocumentsPage}/>
        <PrivateRoute path="/teamdashboard" exact={true} component={TeamDashboard} />
        <PrivateRoute path="/teamdashboardadmin" exact={true} component={TeamDashboard} />
        <PrivateRoute path="/dealershipdashboard" exact={true} component={DealershipDashboard} />
        <PrivateRoute path="/PostSurvey" exact={true} component={PostSurvey} />
        <PrivateRoute path="/admin" exact={true} component={AdminPage} />
        <PrivateRoute path="/admin/dealerships/:id" exact={true} component={AdminDealershipPage} />
        <PrivateRoute path="/admin/bootcamps/:id" exact={true} component={AdminBootcampPage} />
        <PrivateRoute path="/racecontrol" exact={true} component={RaceControlPage} />
        <PrivateRoute path="/racecontrol/:campId/reps/:userId" exact={true} component={RaceRepPage} />
        <PrivateRoute component={NotFoundPage} />
      </Switch>
      {/* Lives outside the routes so a nudge keeps its timing as the rep moves between pages. */}
      <Route render={() => (auth.isAuthenticated() ? <NudgeToast /> : null)} />
    </div>
  </Router>
);

export default AppRouter;
